var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMarkdown(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1714120415073,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 16291,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M624.3 320c-26.4 0-48-21.6-48-48V0h-400C149.7 0 128.3 21.4 128.3 48v928c0 26.6 21.4 48 48 48h672c26.6 0 48-21.4 48-48V320h-272z m98 552.8c0 12.8-10.4 23.2-23.2 23.2h-39.6c-12.8 0-23.2-10.4-23.2-23.2v-228L550.7 838c-3.8 8.4-12 13.8-21.2 13.8h-34.8c-9.2 0-17.4-5.4-21.2-13.8l-85.6-192.6v227.6c0 12.8-10.4 23.2-23.2 23.2H325.5c-12.8 0-23.2-10.4-23.2-23.2v-394c0-12.8 10.4-23.2 23.2-23.2h50.6c9.2 0 17.6 5.6 21.2 14L512.5 734l115-264.4c3.6-8.6 12-14 21.2-14h50.4c12.8 0 23.2 10.4 23.2 23.2v394z",
    fill: "#01998A",
    "p-id": 16292
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M895.3 243.8c0-12.6-5-24.8-14-33.8L685.5 14c-9-9-21.2-14-34-14h-12.2v256h256v-12.2z",
    fill: "#01998A",
    "p-id": 16293
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkdown);
export default __webpack_public_path__ + "static/media/markdown.a9819b39a9d36d494d4eeb685730b929.svg";
export { ForwardRef as ReactComponent };